import { atom } from 'jotai';

export const isUnpaidInvoicesModalOpenAtom = atom<boolean>(false);
isUnpaidInvoicesModalOpenAtom.debugLabel = 'isUnpaidInvoicesModalOpenAtom';
